import { useEffect } from "react";
import { ref, onValue } from "../../../Config/matuRtdb";
import { database } from "../../../Config/firebase";
import ReactDOM from "react-dom/client";
import FootballLoading from "../../../Utils/FootballLoading";

const VersionWatcher = () => {
  useEffect(() => {
    const versionRef = ref(database, "App/Config/version_name");
    const versionActual = localStorage.getItem("versionApp");

    onValue(versionRef, (snapshot) => {
      const nuevaVersion = snapshot.val();

      if (nuevaVersion && nuevaVersion !== versionActual) {
        localStorage.setItem("versionApp", nuevaVersion);

        // Crear un contenedor para el loader
        const container = document.createElement("div");
        document.body.innerHTML = ""; // Limpiar body
        document.body.appendChild(container);

        // Montar el componente de carga
        const root = ReactDOM.createRoot(container);
        root.render(<FootballLoading />);

        setTimeout(() => {
          window.location.reload(); // Recarga forzada
        }, 1000); // Le damos 1 segundo para mostrar el loader
      }
    });
  }, []);

  return null;
};

export default VersionWatcher;
